import type { SupportSubmissionRequest } from "./supportTypes";

const emailPattern =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function hasValue(value: string): boolean {
  return value.length > 0;
}

export function hasValidEmail(value: string): boolean {
  return hasValue(value) && emailPattern.test(value.toLowerCase());
}

export function validateSupportForm(
  request: SupportSubmissionRequest,
  countryRequired: boolean,
  captchaRequired: boolean,
): {
  email: boolean;
  message: boolean;
  name: boolean;
  country: boolean;
  captcha: boolean;
} {
  return {
    email: hasValidEmail(request.email),
    message: hasValue(request.message),
    name: hasValue(request.name),
    country: !countryRequired || hasValue(request.country),
    captcha: !captchaRequired || hasValue(request.captchaInput),
  };
}
